'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth';

export function AuthBootstrap() {
  useEffect(() => {
    void useAuthStore.getState().loadFromStorage();
  }, []);

  return null;
}
